/* eslint sort-keys: "error" */
/* eslint-env es6 */
import { Themes } from '@sainsburys-tech/bolt'
import { HabitatVocab } from '@sainsburys-tech/bolt-vocab-provider'

const habitat = {
  backInStock: {
    key: 'BACK_IN_STOCK_KEY_HABITAT',
    proxyPath: '/pi-habitat-back-in-stock',
    url: 'BACK_IN_STOCK_URL_HABITAT'
  },
  bolt: {
    namespace: 'bolt-habitat'
  },
  bzKey: 'BAZAARVOICE_KEY_HABITAT',
  canonicalBase: 'https://www.habitat.co.uk',
  channel: 'habitat_uk',
  metaDescription: 'Thousands of products for same day delivery, or fast store collection.',
  tealiumPath: 'argos/habitat',
  theme: Themes.HabitatTheme,
  vocab: HabitatVocab
}

const HabitatFeatures = {
  ASK_QUESTION: true,
  ATT_MODAL_HIDE_CATEGORIES: true,
  ATT_MODAL_HIDE_EXTRAS: false,
  BASE_URL: 'www.habitat.co.uk',
  BREADCRUMB: true,
  BV_WRITE_REVIEW: false,
  CATEGORY_EXPERIENCES_TEMPLATE_ENABLED: true,
  CNET: true,
  COMPARISON_ATTRIBUTES: false,
  COMPLETE_THE_LOOK: false,
  CUSTOMER_GENERATED_CONTENT: false,
  DESCRIPTION_CLASS: 'xs-12--none md-7--none xl-8--none',
  EMAIL_ME_BACK: {
    ctaText: 'Notify me',
    enabled: true,
    excludedSkus: [],
    position: 'deliveryBox',
    proxyPath: habitat.backInStock.proxyPath,
    source: null
  },
  ENERGY_SAVING: false,
  ESSENTIAL_EXTRAS: true,
  FABLE_ATT: true,
  FEATURED_PRODUCTS: false,
  FREQUENTY_BROUHT_TOGETHER: true,
  GO_IN_STORE: true,
  KLARNA_CREDITPLAN: true,
  KLARNA_MESSAGING: {
    dcid:
      'klarna_live_client_KUxUdGpKV2l2TjFTRy9SU2JXU3V6d1NPRTlzSDJUaSUsZWQ0NTYxZWMtYmFlNi00OTEwLWEzNDgtYWVhOTc5MWFmYjc3LDEsU1Fld1ZvNk5VSVlTQ2ViaGVwWm56aHp0ZVNocXBCVU40eG1ST0NONllRTT0',
    enabled: true
  },
  MEDIA_CLASS: 'xs-12--none md-8 xl-8',
  MEDIA_PORTRAIT: false,
  MONTHLY_PAYMENT_PLAN: false,
  NECTAR: true,
  PAYPAL_IFC_MESSAGING: true,
  PAYPAL_MESSAGING: true,
  PRICING_CLASS: 'xs-12--none md-4--none xl-4--none',
  Q_AND_A: true,
  REVIEWS: false,
  REVIEWS_WRITE_REVIEW_ENABLED: false,
  SHOP_COLLECTION: true,
  SHOP_THE_LOOK: {
    SHOP_THE_LOOK_ENABLED: true,
    SHOP_THE_LOOK_EXCLUDED_CATEGORIES: [],
    SHOP_THE_LOOK_EXCLUDED_SKUS: [],
    SHOP_THE_LOOK_ONLY_INCLUDED_CATEGORIES: []
  },
  SHOW_ARGOSCARD_LOGO_FINANCE_ACCORDION: true,
  SIMILAR_ITEMS: true,
  SOLD_BY_ARGOS: true,
  SPECIFICATION_TABLE: false,
  STICKY_BAR: true,
  SYTE: {
    SYTE_ACCOUNT_ID: '9251',
    SYTE_BUTTON: true,
    SYTE_SIGNATURE: '608bd79f2f21645d9c4f83be'
  },
  TEMPLATE_TYPE: 'HABITAT',
  WISHLIST: false
}

export { habitat }
export default HabitatFeatures
